import { oauthAccessToken } from '@/features/auth/oauthAccessToken'
import { oauthTokenRefresh } from '@/features/auth/oauthTokenRefresh'
import { ApolloLink, fromPromise } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { ServerError } from '@apollo/client/link/utils'

export const authLink = setContext((_, prevContext) => {
    const token = oauthAccessToken.get()

    if (!token) return prevContext

    return {
        ...prevContext,
        headers: {
            ...prevContext.headers,
            Authorization: `Bearer ${token}`,
        },
    }
})

const isServerError = (networkError: Error | null | undefined): networkError is ServerError => {
    return !!networkError && 'statusCode' in networkError
}

const refreshAuthLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    const { oauthRefreshAttempted } = operation.getContext()

    if (oauthRefreshAttempted) return

    const hasUnauthenticatedGraphQLError = graphQLErrors?.some(
        (error) => error.extensions?.code === 'UNAUTHENTICATED'
    )
    const hasUnauthorizedNetworkError =
        isServerError(networkError) && networkError.statusCode === 401

    if (!hasUnauthenticatedGraphQLError && !hasUnauthorizedNetworkError) return

    return fromPromise(oauthTokenRefresh.refreshAccessToken()).flatMap((token) => {
        operation.setContext(({ headers = {}, ...context }) => ({
            ...context,
            oauthRefreshAttempted: true,
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        }))

        return forward(operation)
    })
})

export const oauthLink = ApolloLink.from([authLink, refreshAuthLink])
